export default __webpack_public_path__ + "static/media/card-profile6-square.9f286150.jpg";